import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue";
const _hoisted_1 = { style: { "display": "flex", "gap": "10px", "padding": "7px", "border": "1px solid lightgrey", "border-radius": "4px" } };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("label", { for: "all_websites_checked" }, "Include technical sites", -1);
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { style: { "display": "flex", "gap": "10px", "padding": "7px", "border": "1px solid lightgrey", "border-radius": "4px" } };
import OneDeskMultiSelect from "@/components/atoms/OneDeskMultiSelect.vue";
import OneDeskDropdown from "@/components/atoms/OneDeskDropdown.vue";
import Checkbox from "primevue/checkbox";
import { computed, useSlots, watch } from "vue";
import { useStore } from "@/shared/composables/useStore";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import { SearchTarget } from "@/shared/enums/SearchTarget.enum";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InventorySearch',
    props: {
        "modelValue": { required: true },
        "modelModifiers": {},
    },
    emits: ["update:modelValue"],
    setup(__props) {
        const modelValue = _useModel(__props, "modelValue");
        const store = useStore();
        const slots = useSlots();
        const groupByOptions = computed(() => [{ label: `Brands`, value: "brand" }, { label: `Markets`, value: "market" }]);
        const searchingInSites = computed(() => {
            return modelValue.value.searchPerimeter.length === 1 ||
                modelValue.value.searchText !== '' ||
                modelValue.value.brands.length > 0 ||
                modelValue.value.markets.length > 0;
        });
        const distinctBrandList = computed(() => store.getters[ReferenceValuesTypes.BRANDS]);
        const distinctMarketList = computed(() => store.getters[ReferenceValuesTypes.MARKETS]);
        const hasActionsSlot = !!slots.actions?.();
        watch(() => [
            modelValue.value.searchText,
            modelValue.value.brands,
            modelValue.value.markets
        ], () => {
            updateSearchTarget();
        }, { deep: true });
        const updateSearchTarget = () => {
            if (modelValue.value.searchPerimeter.length === 1)
                return;
            if (searchingInSites.value)
                modelValue.value.searchTarget = SearchTarget.site;
            else
                modelValue.value.searchTarget = SearchTarget.brand;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(OneDeskMultiSelect, {
                    "data-testid": "search-brands-multi-select",
                    modelValue: modelValue.value.brands,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((modelValue.value.brands) = $event)),
                    filter: "",
                    options: distinctBrandList.value,
                    lineraLabel: false,
                    optionValue: "id",
                    optionLabel: "label",
                    placeholder: "Brands"
                }, null, 8, ["modelValue", "options"]),
                _createVNode(OneDeskMultiSelect, {
                    "data-testid": "search-markets-multi-select",
                    modelValue: modelValue.value.markets,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((modelValue.value.markets) = $event)),
                    filter: "",
                    options: distinctMarketList.value,
                    lineraLabel: false,
                    optionValue: "id",
                    optionLabel: "label",
                    placeholder: "Markets"
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_unref(Checkbox), {
                            modelValue: modelValue.value.allWebsitesChecked,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((modelValue.value.allWebsitesChecked) = $event)),
                            inputId: "all_websites_checked",
                            name: "allWebsitesChecked",
                            binary: ""
                        }, null, 8, ["modelValue"]),
                        _hoisted_2
                    ])
                ]),
                (!searchingInSites.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(OneDeskDropdown, {
                            "data-testid": "search-target-dropdown",
                            modelValue: modelValue.value.searchTarget,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((modelValue.value.searchTarget) = $event)),
                            options: groupByOptions.value
                        }, null, 8, ["modelValue", "options"])
                    ]))
                    : _createCommentVNode("", true),
                hasActionsSlot
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _renderSlot(_ctx.$slots, "actions")
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
